import styled from "styled-components";

import styleConst from "constants/style";

import background from "assets/images/svg/sign_in_background.svg";
import logo from "assets/images/svg/logo_full.svg";

export const Background = styled.div`
  display: flex;

  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;

  width: 100%;
  height: 100%;

  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 600px;
  padding: 80px 60px;

  box-shadow: 5px 20px 30px ${styleConst.colors.shadow};

  border-radius: 10px;

  background-color: ${styleConst.colors.white};
`;

export const LogoContainer = styled.div`
  display: flex;

  justify-content: center;
  align-items: flex-start;

  margin-bottom: 45px;
`;

export const Logo = styled.img.attrs({ src: logo })``;

export const Title = styled.p`
  font-family: ${styleConst.fonts.montserrat};
  font-weight: 600;
  font-size: 22px;
  line-height: 23px;

  text-align: center;
`;
export const SubTitle = styled.p`
  margin-top: 10px;

  font-family: ${styleConst.fonts.montserrat};
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;

  text-align: center;
`;
